export default __webpack_public_path__ + "static/media/research2.e44d86eb.jpg";